import i18n from '@/i18n/index';

export default {
  cache:(state)=>{
    const trackingDomainsObject = state?.cache?.trackingDomains?.data?.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {}) || {}
    
    const affiliateNetworksObject = state?.cache?.affiliateNetworks?.data?.reduce((acc, item) => {
      acc[item.id] = item
      return acc
    }, {}) || {}

    return {
      trackingDomainsObject,
      affiliateNetworksObject,
      trackingDomainsWithAccountDefault:[
        {
          domain: i18n.vm.t('Account default'),
          id: '',
          direct: false
        },
        ...(state?.cache?.trackingDomains?.data || [])
      ],
      redirectDomainsWithAccountDefault:[
        {
          domain: i18n.vm.t('Account default'),
          id: '',
        },
        ...(state?.cache?.redirectDomains?.data || [])
      ]
    }
  }
};